import Purchase from "../components/Purchase.vue";
import Withdraw from "../components/Withdraw.vue";
import Operator from "../components/Operator.vue";
import { createRouter, createWebHistory } from "vue-router";
import Games from "@/views/Games.vue";
import Login from "@/views/Login.vue";
import Register from "@/views/Register.vue";
import Verify from "@/views/Verify.vue";

const routes = [
  {
    path: "/",
    redirect: "/games",
  },
  {
    path: "/games",
    name: "Games",
    component: Games,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
  },
  {
    path: "/verify",
    name: "Verify",
    component: Verify,
    meta: { requiresAuth: true },
  },
  { 
    path: "/purchase", 
    component: Purchase,
    meta: { requiresAuth: true }
  },
  { 
    path: "/withdraw", 
    component: Withdraw,
    meta: { requiresAuth: true }
  },
  { 
    path: "/operator", 
    component: Operator,
    meta: { requiresAuth: true }
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Check if user is logged in
function isAuthenticated() {
  try {
    const userData = localStorage.getItem("demoUserData");
    if (!userData) return false;
    
    const parsedData = JSON.parse(userData);
    return !!(parsedData && parsedData.username);
  } catch (error) {
    console.error("Error checking authentication:", error);
    return false;
  }
}

// Navigation guard for protected routes
router.beforeEach((to, from, next) => {
  // Check if route requires authentication
  if (to.meta.requiresAuth) {
    if (isAuthenticated()) {
      // User is logged in, proceed to route
      next();
    } else {
      // User is not logged in, redirect to login
      console.log("Access denied: User not logged in, redirecting to login");
      next("/login");
    }
  } else {
    // Route doesn't require authentication, proceed
    next();
  }
});

export default router;
